import { OrderStatus } from '~/models/marketplace/order'

export const marketplaceCartMaxQuantity = 20

export const marketplaceEshopOnboardingSkippedCookieName =
  'eshopOnboardingSkipped'

export const orderCompletedStatuses = [
  OrderStatus.DELIVERED,
  OrderStatus.COMPLETED,
  OrderStatus.RETURNED
]

export const orderNewStatuses = [OrderStatus.PENDING_ACCEPTANCE]

export const orderFailStatuses = [
  OrderStatus.CANCELED_BY_USER,
  OrderStatus.CANCELED_BY_SELLER,
  OrderStatus.DECLINED,
  OrderStatus.COULD_NOT_BE_DELIVERED,
  OrderStatus.RETURN_DECLINED,
  OrderStatus.RETURNED
]

export const orderPendingStatuses = [
  OrderStatus.PENDING_ACCEPTANCE,
  OrderStatus.ACCEPTED,
  OrderStatus.PENDING_COLLECTION_OF_ITEMS,
  OrderStatus.PENDING_SHIPMENT,
  OrderStatus.SHIPPED,
  OrderStatus.PENDING_DELIVERY,
  OrderStatus.RETURN_REQUESTED,
  OrderStatus.RETURN_ACCEPTED,
  OrderStatus.PENDING_PAYMENT,
  OrderStatus.READY_FOR_PICKUP
]

export const orderSuccessStatuses = [
  OrderStatus.DELIVERED,
  OrderStatus.COMPLETED,
  OrderStatus.DELIVERED_VALID_FOR_RETURN
]
